export default __webpack_public_path__ + "static/media/cloud-2.a1d424dd.webp";